import Icon from "./Icon";
import { careServices, siteDetails } from "../siteContent";

const Services = () => (
  <section className="section" id="care">
    <div className="container">
      <div className="section-heading section-heading--centred">
        <p className="eyebrow">Our care</p>
        <h2>Practical support, delivered with warmth</h2>
        <p>
          Every enquiry begins with understanding the person and whether Ascot
          Lodge can safely meet their needs.
        </p>
      </div>

      <div className="card-grid card-grid--three">
        {careServices.map(({ icon, title, description }) => (
          <article className="care-card" key={title}>
            <span className="icon-tile">
              <Icon name={icon} size={27} />
            </span>
            <h3>{title}</h3>
            <p>{description}</p>
          </article>
        ))}
      </div>

      <div className="trust-panel">
        <div className="trust-panel__rating">
          <span className="trust-panel__mark">CQC</span>
          <div>
            <p>Overall rating</p>
            <strong>Good</strong>
          </div>
        </div>
        <div className="trust-panel__copy">
          <p className="eyebrow">Independent reassurance</p>
          <h3>Rated Good in all five inspection areas</h3>
          <p>
            The Care Quality Commission's report, published on{" "}
            {siteDetails.cqcReportDate}, rated Ascot Lodge Good for safe,
            effective, caring, responsive and well-led care.
          </p>
        </div>
        <a
          className="button button--light"
          href={siteDetails.cqcUrl}
          rel="noreferrer"
          target="_blank"
        >
          View the CQC profile
          <Icon name="external" size={18} />
        </a>
      </div>
    </div>
  </section>
);

export default Services;
